var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import GrimoireInterface from "./Interface/GrimoireInterface";
import GomlLoader from "./Node/GomlLoader";
/**
 * Provides procedures for initializing.
 */
class GrimoireInitializer {
    /**
     * Start initializing
     * @return {Promise<void>} The promise which will be resolved when all of the Goml script was loaded.
     */
    static initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                GrimoireInitializer._notifyLibraryLoadingToWindow();
                GrimoireInitializer._copyGLConstants();
                GrimoireInterface.initialize();
                yield GrimoireInitializer._waitForDOMLoading();
                yield GrimoireInitializer._waitForPluginLoadingSuspendPromise();
                GrimoireInitializer._logVersions();
                yield GrimoireInterface.resolvePlugins();
                yield GomlLoader.loadForPage();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    /**
     * Ensure WebGLRenderingContext.[CONSTANTS] is exisiting.
     * Some of the browsers contains them in prototype.
     */
    static _copyGLConstants() {
        if (WebGLRenderingContext.ONE) {
            // Assume the CONSTANTS are already in WebGLRenderingContext
            // Chrome,Firefox,IE,Edge...
            return;
        }
        // Otherwise like ""Safari""
        for (let propName in WebGLRenderingContext.prototype) {
            if (/^[A-Z]/.test(propName)) {
                const property = WebGLRenderingContext.prototype[propName];
                WebGLRenderingContext[propName] = property;
            }
        }
    }
    /**
     * Obtain the promise object which will be resolved when DOMContentLoaded event was rised.
     * @return {Promise<void>} the promise
     */
    static _waitForDOMLoading() {
        return new Promise((resolve) => {
            if (document.readyState === "loading") {
                window.addEventListener("DOMContentLoaded", () => {
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    }
    static _logVersions() {
        const gr = GrimoireInterface;
        if (!gr.debug) {
            return;
        }
        let log = `%cGrimoire.js v${gr["__VERSION__"]}\nplugins:\n\n`;
        let i = 1;
        for (let key in gr.lib) {
            const plugin = gr.lib[key];
            log += `  ${i} : ${plugin.__NAME__ || key}@${plugin.__VERSION__}\n`;
            i++;
        }
        log += `\nTo suppress this message,please inject a line "gr.debug = false;" on the initializing timing.`;
        console.log(log, "color:#44F;font-weight:bold;");
    }
    static _notifyLibraryLoadingToWindow() {
        window.postMessage({
            $source: "grimoirejs",
            $messageType: "library-loading"
        }, "*");
    }
    static _waitForPluginLoadingSuspendPromise() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!GrimoireInterface.libraryPreference) {
                return;
            }
            yield GrimoireInterface.libraryPreference["postponeLoading"];
        });
    }
}
/**
 * Just start the process.
 */
export default function () {
    const gwin = window;
    if (gwin.GrimoireJS) {
        GrimoireInterface.libraryPreference = gwin.GrimoireJS;
    }
    GrimoireInterface.noConflictPreserve = gwin.gr;
    gwin.gr = gwin.GrimoireJS = GrimoireInterface;
    GrimoireInitializer.initialize();
    return GrimoireInterface;
}



// WEBPACK FOOTER //
// ./src/main.ts